export default __webpack_public_path__ + "static/media/Path3409.7361dc7f.svg";